<template>
  <div>
    <span>{{ datetime }}</span>
    <el-tooltip v-if="errorSign" class="right" effect="dark" :content="message" placement="top">
      <div>
        <i class="el-icon-warning" style="color:red;" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import dayjs from "dayjs"
export default {
  name: 'IkTableDatetimeTag',
  props: {
    value: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    defaultValue: {
      type: String,
      default: ''
    },
    errorSign: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      val: ''
    }
  },
  computed: {
    datetime() {
      return dayjs(this.value).format("YYYY-MM-DD HH:mm:ss")
    }
    // datetime: function() {
    //   const $this = this
    //   if ($this.value === '' || $this.value === null) {
    //     if (this.defaultValue.indexOf('Now') !== -1) {
    //       return reFormat(this.defaultValue, this.format)
    //     } else {
    //       return this.defaultValue
    //     }
    //   } else {
    //     return reFormat($this.value, $this.format)
    //   }
    // }
  }
}
</script>

<style lang="scss">
.el-tag {
  margin-left: 10px;
}
</style>
